type QueuedPromise<T> = () => Promise<T>;

type Task = {
  promise: QueuedPromise<unknown>;
  resolve: (value: any) => void;
  reject: (error?: any) => void;
};

function createQueue() {
  const queue: Task[] = [];

  let workingOnPromise = false;

  function enqueue<T>(promise: QueuedPromise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      queue.push({ promise, reject, resolve });

      processQueue();
    });
  }

  async function processQueue(): Promise<void> {
    if (workingOnPromise) {
      return;
    }

    const item = queue.shift();

    if (!item) {
      return;
    }

    try {
      workingOnPromise = true;

      const value = await item.promise();

      item.resolve(value);
    } catch (err) {
      item.reject(err);
    } finally {
      workingOnPromise = false;

      processQueue();
    }
    return;
  }

  return { enqueue };
}

export const favoriteQueue = createQueue();
